import { axios } from '../../clients/axios'

// Unused. Plan to use in the future for more notifications.
export default {
  namespaced: true,
  state: {
    appBarNotifications: []
  },
  getters: {
    getAppBarNotifications: (state) => {
      return state.appBarNotifications
    }
  },
  mutations: {
    fetchAppBarNotifications: (state, notifications) => {
      state.appBarNotifications = notifications
    }
  },
  actions: {
    async fetchAppBarNotificationsAction(context) {
      const notifications = await axios.get(
        `${process.env.VUE_APP_API_URL}/appBarNotifications`,
        { withCredentials: true }
      )
      context.commit('fetchAppBarNotifications', notifications.data)
    },
    async setReadAppBarNotificationsAction(context, params) {
      const { refNo } = params
      const notifications = await axios.put(
        `${process.env.VUE_APP_API_URL}/appBarNotifications/read`,
        { refNo: refNo },
        { withCredentials: true }
      )

      return notifications.data
    }
  }
}
